import { defineComponent as _defineComponent } from 'vue'
import { buryPoint } from '@/apis/common/buryPoint'
import { getEquipmentChangeRecordsList } from '@/apis/equipment'
import {
  getPrelayoutSetting,
  savePrelayoutSetting,
} from '@/apis/preLayoutSetting'
import AnchorNav from '@/components/anchorNav/index.vue'
import MAccordTextureCut from '@/components/engraving/m-accord-texture-cut.vue'
import mSpecialHoleAndSlotTable from '@/components/engraving/specialHoleAndSlotTable.vue'
import { Navigate } from '@/components/g-search/utils'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { scrollToElementFn, verifyInputNumber } from '@/util/commonFuncs'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import { message } from 'ant-design-vue'
import Vue, { nextTick, onUnmounted } from 'vue'
import { computed, onMounted, reactive, ref, watch } from 'vue'

import { checkPrelayoutSettingChanged } from '../materialsList/util/preLayoutDeal'
import mHistoryList from './components/m-history-list.vue'
import mMachinePos from './components/m-machine-pos.vue'
import mSettingContent from './components/m-setting-content.vue'
import { preLayoutSettingNavs } from './config'
import { HistoryType } from './type'
import { genCompareFormRecord } from './util/dealARecord'
import {
  preLayoutSettingConfigCompareList,
  preLayoutSettingConfigMap,
  preLayoutSettingConfigValues,
} from './util/recordConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const info = () => {
  message.warning('请选择特殊孔槽')
}
// 通用设置，二级内容开关
const engravSwitchCloseAlwaysShow = computed(
  () => store.state.preferencesSetting?.setting.engravSwitchCloseAlwaysShow
)

const paringPointList = ref([
  { label: 'cuttingDock.cuttingParams.topLeft', value: 'topLeft' },
  { label: 'cuttingDock.cuttingParams.bottomLeft', value: 'bottomLeft' },
  { label: 'cuttingDock.cuttingParams.topRight', value: 'topRight' },
  { label: 'cuttingDock.cuttingParams.bottomRight', value: 'bottomRight' },
]) // 记录修边方向可选项
function paringImg(val: string) {
  switch (val) {
    case 'topLeft':
      return require('@/assets/fiveSixSet/paringLT.png')
    case 'bottomLeft':
      return require('@/assets/fiveSixSet/paringLB.png')
    case 'topRight':
      return require('@/assets/fiveSixSet/paringRT.png')
    case 'bottomRight':
      return require('@/assets/fiveSixSet/paringRB.png')
  }
  return require('@/assets/fiveSixSet/paringLT.png')
}

const anchorNavRef = ref(null)
const positionDisList = [
  {
    position: 'cuttingDock.cuttingParams.bottomLeftD',
    key: '左下角',
    value: '+x,+y',
  },
  {
    position: 'cuttingDock.cuttingParams.topLeftD',
    key: '左上角',
    value: '+x,-y',
  },
  {
    position: 'cuttingDock.cuttingParams.bottomRightD',
    key: '右下角',
    value: '-x,+y',
  },
  {
    position: 'cuttingDock.cuttingParams.topRightD',
    key: '右上角',
    value: '-x,-y',
  },
]
const lavePointList = ref([
  { label: '左上角', value: 'topLeft' },
  { label: '左下角', value: 'bottomLeft' },
  { label: '右上角', value: 'topRight' },
  { label: '右下角', value: 'bottomRight' },
])

// 夹手位置
// 夹手方向map映射
const clampHandDirectionMap = new Map([
  ['左侧', 'L'],
  ['右侧', 'R'],
  ['上侧', 'T'],
  ['下侧', 'B'],
])
const clampHandPositioin = [
  {
    label: '左侧',
    value: clampHandDirectionMap.get('左侧'),
  },
  {
    label: '右侧',
    value: clampHandDirectionMap.get('右侧'),
  },
  {
    label: '上侧',
    value: clampHandDirectionMap.get('上侧'),
  },
  {
    label: '下侧',
    value: clampHandDirectionMap.get('下侧'),
  },
] as const

const container = computed(() => anchorNavRef.value as unknown as HTMLElement)
const navs = computed(() => preLayoutSettingNavs)
const positionDisValue = computed(() => {
  return positionDisList.find(
    (dis) => dis.key == formData.countertopSetting.startPosition
  )?.value
})
const plateGighGlossOptions = ref([
  {
    label: 'common.front',
    value: 'front',
  },
  {
    label: 'common.back',
    value: 'back',
  },
])

const secondaryCuttingList = ref<any[]>([])
const secondaryCuttingOptions = ref([
  {
    label: 'cuttingDock.cuttingParams.thickRange',
    checkedValueKey: 'cutSingleDoor',
    inputValueKey: 'single_door_thick',
    text: 'common.textOfDoorPlank',
  },
  {
    label: 'cuttingDock.cuttingParams.thickRange',
    checkedValueKey: 'cutGeneralPlank',
    inputValueKey: 'generalPlankThick',
    text: 'common.textOfNotDoorPlank',
  },
])
const isLoadingSetting = ref(true)
const settingId = ref(0)
const hasChangeSetting = ref(false)
const isHistoryVisible = ref(false)
const historyList = ref<HistoryType[]>([])
const isHistoryListLoading = ref(false)
const historyItem = ref<any>(null)
const currentItemIndex = ref()
//是否展自定义特殊孔槽
const isShowCustSPHoleRule = ref(false)
const specialHoleSlotRef = ref<any>()
const specialHoleSlotRef2 = ref<any>()
const formData = reactive({
  knife: {
    diameter: 6,
  },
  holeFaceSetting: {
    holeConcentrated: 'front',
    prorate_holes_slots_of_both_side: false,
    apertureSlotConcentrated: 'front',
    throughHoleSlotSameSide: true,
    percentage_of_back_hole_slot: 50,
    // 特殊孔槽加工面
    custom_special_hole_slot_side: {
      is_open: false,
      special_hole_slot_side: [],
    },
  },
  highgloss_setting: {
    highgloss_direction: 'back',
    auto_high_gloss_reverse: false,
    high_gloss_plank_no_rotate: false,
  },
  edgePlankSlotDirection: { sideBoardPlacing: 'default' },
  countertopSetting: {
    startPosition: '左下角',
    xyReverse: false,
    counter_limit_able: false,
    counter_width: 1300,
  },
  // as { [key: string]: any },
  longPlankCuttingSetting: {
    longPlankCuttingEnable: false,
    vacuumPumpPauseWay: 'after_all_plank',
    longPlankShortExpandedSize: 2,
    longPlankExpandedSize: 2,
    longPlankMinLength: 1500,
    longPlankShortMinLength: 200,
    generalPlankThick: 0,
    single_door_thick: 0,
    cutSingleDoor: true,
    cutGeneralPlank: true,
    // 异形二次切割开关
    curveSecondCutEnable: true,
    // 指定材质开关
    desMaterialSwitch: false,
    // 指定材质列表
    desMaterialList: [],
    // 指定板件名称二次切割开关
    specified_board_secondary_cutting: false,
    // 指定板件名称二次切割列表
    secondary_cutting_board_list: [] as string[],
    // 指定板名强制生效
    force_board_name: false,
  },
  trimmingSetting: {
    trimSide: 'bottomRight',
  },
  surplusSetting: {
    surplusPosition: 'topRight',
  },
  decimalSetting: { decimal: 2 },
  boardGapsSetting: {
    boardGap: 0.1,
  },
  barCodeSetting: {
    uniqueBarCode: false,
    genSimpleLabelBarcode: false,
  },
  cuttingPunchingSetting: {
    throughTowSideToCut: false,
    through_slot_two_side_cut: false,
    non_through_slot_two_side_cut: {
      // 是否设置不生效翻面两次打穿孔
      is_open: false,
      special_hole_slot_side: [],
    },
  },
  movePlankSetting: {
    scattered_layout: false,
    safe_length: [300, 500],
  },
  integrationDeviceSetting: {
    enable_integration_device: false,
    aio_fixture_setting: {
      aio_avoid_fixture: false,
      aio_fixture_length: 0,
      aio_fixture_width: 0,
      aio_first_fixture_height: 0,
      aio_second_fixture_height: 0,
      aio_fixture_direction: 'L',
    },
  },
  sawSetting: {
    mentaoji_enable: false,
    processType: 'weldingPlank',
    // 启用锯片厚度排版
    sawToLayout: false,
    horizontalWidth: '',
    edgeNoSaw: false,
    edgeNoSawSide: 'left',
    sameWidthPlank: false,
    noCutEmptyPath: false,
  },
})
const accordTextureCut = ref()
// 已封好边不再切方向
const edgeDirArr = ref([
  { label: 'cuttingDock.sawEngraving.top', value: 'top' },
  { label: 'cuttingDock.sawEngraving.bottom', value: 'bottom' },
  { label: 'cuttingDock.sawEngraving.left', value: 'left' },
  { label: 'cuttingDock.sawEngraving.right', value: 'right' },
])
let currentInputPlankName = ref('')
let currentInputIndex = ref<number | null>(null)
// 存储每个输入框的临时值和原始值
const tempPlankNames = reactive<
  Record<number, { value: string; original: string }>
>({})

// 选择起始工位
const handleChosePoint = (val: string) => {
  formData.countertopSetting.startPosition = val
}

// 选择修边方向
function handleParDir(val: string) {
  formData.trimmingSetting.trimSide = val
}

const laveImg = computed(() => {
  switch (formData.surplusSetting.surplusPosition) {
    case 'bottomLeft':
      return require('./assets/lb.png')
    case 'topLeft':
      return require('./assets/lt.png')
    case 'bottomRight':
      return require('./assets/rb.png')
    case 'topRight':
      return require('./assets/rt.png')
    default:
      return require('./assets/rt.png')
  }
})

const lavePoint = computed(() => {
  const p = lavePointList.value.find(
    (item) => formData.surplusSetting.surplusPosition === item.value
  )
  return p ? p.label : '右上角'
})

const isLongPlankCuttingDisabled = computed(
  () => !formData.longPlankCuttingSetting.longPlankCuttingEnable
)
// 监听特殊孔槽规则的变化
// watch(
//   () => specialHoleSlotRef.value?.bindValList ?? [],
//   (val) => {
//     if (val && val.length > 0) {
//       formData.holeFaceSetting.custom_special_hole_slot_side.special_hole_slot_side =
//         val
//     }
//   },
//   {
//     deep: true,
//   }
// )
watch(
  () => formData,
  (val) => {
    hasChangeSetting.value = checkPrelayoutSettingChanged(
      val,
      store.state.preLayoutSetting.setting_value
    )
  },
  {
    deep: true,
  }
)
watch(
  () => formData.movePlankSetting,
  (val) => {
    if (!val.safe_length) {
      Vue.set(formData.movePlankSetting, 'safe_length', [300, 500])
    }
  },
  {
    deep: true,
  }
)
const handleChoselavePoint = (val: any) => {
  const p = lavePointList.value.find((item) => item.label === val)
  formData.surplusSetting.surplusPosition = p ? p.value : 'topRight'
}
// 选择二次切割
const handleSelectCutting = (e: any) => {
  formData.longPlankCuttingSetting.cutSingleDoor = e.includes('cutSingleDoor')
  formData.longPlankCuttingSetting.cutGeneralPlank =
    e.includes('cutGeneralPlank')
}
const handlerChangeAccordMSw = (data: boolean) => {
  formData.longPlankCuttingSetting.desMaterialSwitch = data
}
// 将对象解构成一层
const handleFlattenObject = (obj: any, parentKey = '') => {
  let result: any = {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      // const fullKey = parentKey ? `${parentKey}.${key}` : key
      if (
        typeof obj[key] === 'object' &&
        obj[key] !== null &&
        !Array.isArray(obj[key])
      ) {
        Object.assign(result, handleFlattenObject(obj[key], key))
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}
// 埋点处理
const handleBury = (currentData: any, oldData: any) => {
  const radioArr = [
    'apertureSlotConcentrated',
    'holeConcentrated',
    'throughTowSideToCut',
    'through_slot_two_side_cut',
    'highgloss_direction',
    'auto_high_gloss_reverse',
    'sideBoardPlacing',
    'startPosition',
    'trimSide',
    'surplusPosition',
    'vacuumPumpPauseWay',
    'counter_limit_able',
    'counter_width',
  ]
  const arrKeyList = [
    'special_hole_slot_side',
    'desMaterialList',
    'safe_length',
    'secondary_cutting_board_list',
  ]
  Object.keys(currentData).forEach((key: string) => {
    if (!arrKeyList.includes(key) && currentData[key] != oldData[key]) {
      if (radioArr.includes(key)) {
        buryPoint({
          function_module: 'preLayoutSetting',
          function_point: `${key}_${currentData[key]}`,
        })
      } else {
        buryPoint({ function_module: 'preLayoutSetting', function_point: key })
      }
    } else if (
      arrKeyList.includes(key) &&
      key !== 'desMaterialList' &&
      currentData[key].length &&
      JSON.stringify(currentData[key]) != JSON.stringify(oldData[key])
    ) {
      buryPoint({
        function_module: 'preLayoutSetting',
        function_point: key,
      })
    }
  })
}
/**
 * @desc 保存设置
 */
const handleSaveSetting = async () => {
  dealDataType()
  // 特殊孔槽规则 key 不能设置为空
  const isCanSave = specialHoleSlotRef.value?.scrollToRowAndJudgeIsSave()
  if (isCanSave === false) {
    info()
    return
  }
  const isCanSave2 = specialHoleSlotRef2.value?.scrollToRowAndJudgeIsSave()
  if (isCanSave2 === false) {
    message.warning('请选择孔类型或设置孔直径！')
    return
  }
  if (
    Reflect.has(formData.holeFaceSetting, 'processChainAndHoleOnBigPlaneBack')
  ) {
    Reflect.deleteProperty(
      formData.holeFaceSetting,
      'processChainAndHoleOnBigPlaneBack'
    )
  }
  if (formData.longPlankCuttingSetting.specified_board_secondary_cutting) {
    const condition1 =
      formData.longPlankCuttingSetting.secondary_cutting_board_list.filter(
        (item) => item.trim()
      ).length
    const condition2 =
      formData.longPlankCuttingSetting.secondary_cutting_board_list.some(
        (item) => !item.trim()
      )
    if (!condition1 || condition2) {
      nextTick(() => {
        let dom = document.getElementById('presetting_add_plank_name_btn')
        if (dom) {
          scrollToElementFn(dom)
        }
      })
      message.warning(
        condition2
          ? Vue.prototype.$translateLang('板件名不能为空，请输入') + '！'
          : Vue.prototype.$translateLang('请至少添加一个板件名') + '！'
      )
      return
    }
  }
  saveRecordData(formData, store.state.preLayoutSetting.setting_value)
  handleBury(
    handleFlattenObject(formData),
    handleFlattenObject(store.state.preLayoutSetting.setting_value)
  )
  buryPoint({ function_module: 'preLayoutSetting', function_point: 'save' })
  isLoadingSetting.value = true
  // 保存指定材质的数据
  if (formData?.longPlankCuttingSetting?.longPlankCuttingEnable) {
    accordTextureCut.value?.saveAccordmCut(formData.longPlankCuttingSetting)
  }
  // 特殊孔槽常规孔槽带上索引
  const specialHoleAndSlotTableRules =
    specialHoleSlotRef.value?.getAllRules() ?? {
      is_open: false,
      special_hole_slot_side: [],
    }
  if (specialHoleAndSlotTableRules.is_open) {
    formData.holeFaceSetting.custom_special_hole_slot_side =
      specialHoleAndSlotTableRules
  }
  // 不生效翻面两次打穿孔槽
  const specialHoleAndSlotTableRules2 =
    specialHoleSlotRef2.value?.getAllRules() ?? {
      is_open: false,
      special_hole_slot_side: [],
    }
  if (specialHoleAndSlotTableRules2.is_open) {
    formData.cuttingPunchingSetting.non_through_slot_two_side_cut =
      specialHoleAndSlotTableRules2
  }
  const res = await savePrelayoutSetting({
    setting_value: { ...formData },
    setting_id: settingId.value ? settingId.value : undefined,
  })
  if (res.status) {
    const newSetting = await getPrelayoutSetting()
    isLoadingSetting.value = false
    if (res.data) {
      settingId.value = res.data
    }
    store.commit('setPreLayoutSetting', newSetting.data)
    Vue.prototype.$message({
      message: translate('common.saveSuccess'),
      type: 'success',
    })
  }
}

const saveRecordData = (currentData: any, oriData: any) => {
  // 生成对比数据
  const re1 = genCompareFormRecord(
    currentData,
    oriData,
    preLayoutSettingConfigCompareList,
    {
      formTextObj: preLayoutSettingConfigMap,
      formValueObj: preLayoutSettingConfigValues,
    }
  )
  // 保存操作记录
  saveDataJsonToOssForRecord(re1, 'preLayoutSetting', {
    save_data: currentData,
    setting_id: -2,
    name: '预排版设置',
    operate_equipment: 'preLayoutSetting',
  })
}

/** 确保数据类型为Number */
const dealDataType = () => {
  formData.knife.diameter = Number(formData.knife.diameter)
  formData.holeFaceSetting.percentage_of_back_hole_slot = Number(
    formData.holeFaceSetting.percentage_of_back_hole_slot
  )
  const longCuttingKeyArr: (
    | 'single_door_thick'
    | 'generalPlankThick'
    | 'longPlankExpandedSize'
    | 'longPlankMinLength'
    | 'longPlankShortExpandedSize'
    | 'longPlankShortMinLength'
  )[] = [
    'single_door_thick',
    'generalPlankThick',
    'longPlankExpandedSize',
    'longPlankMinLength',
    'longPlankShortExpandedSize',
    'longPlankShortMinLength',
  ]
  longCuttingKeyArr.forEach((key) => {
    formData.longPlankCuttingSetting[key] = Number(
      formData.longPlankCuttingSetting[key]
    )
  })
  formData.decimalSetting.decimal = Number(formData.decimalSetting.decimal)
  formData.boardGapsSetting.boardGap = Number(
    formData.boardGapsSetting.boardGap
  )
}

const inputLimit = (option: {
  value: string | number
  formData: any
  keys: string[]
  rule: string
  isMinus?: boolean
  min?: number
  isEmpty?: boolean
  max?: number
  isThickFlag?: boolean
}) => {
  verifyInputNumber(
    option.value,
    option.formData,
    option.keys,
    option.rule,
    option.isMinus,
    option.min,
    option.isEmpty,
    option.max,
    option.isThickFlag
  )
}

const onInputBlur = (obj: any, key: string) => {
  obj[key] = Number(obj[key])
}

const handleCheckHistory = async () => {
  isHistoryVisible.value = true
  buryPoint({
    function_module: 'preLayoutSetting',
    function_point: 'editHistory',
  })
  isHistoryListLoading.value = true
  historyItem.value = null
  const res = await getEquipmentChangeRecordsList({
    setting_id: -2,
    operate_equipment: 'preLayoutSetting',
    page: 1,
    limit: 9999,
  })
  isHistoryListLoading.value = false
  if (res.status) {
    const keys = Object.keys(res.data.data)
    historyList.value = keys.map((key) => {
      return {
        createTime: key,
        setting: res.data.data[key],
      }
    })
  }
}

// 夹手位置选择
const handeeChangeClamlHandPosition = (
  val: typeof clampHandPositioin[0]['value']
) => {
  formData.integrationDeviceSetting.aio_fixture_setting.aio_fixture_direction =
    val!
}

const handleCheckDetail = (item: any, index?: number) => {
  historyItem.value = item
  currentItemIndex.value = index
}

const handleReset = async (setting?: any) => {
  Vue.prototype.$antdConfirm({
    title: translateLang('common.warmTip'),
    content: translateLang('preLayoutSetting.resetConfirm'),
    okText: translateLang('common.confirm'),
    cancelText: translateLang('common.cancel'),
    centered: true,
    closable: true,
    onOk: () => {
      resetFunc(setting)
      buryPoint({
        function_module: 'preLayoutSetting',
        function_point: 'editHistoryReset',
      })
    },
  })
}

const resetFunc = async (setting?: any) => {
  isLoadingSetting.value = true
  let saveForm = JSON.parse(setting ?? historyItem.value.setting.save_data)
  try {
    // 判断是否是 OSS 地址
    if (
      typeof saveForm === 'string' &&
      (saveForm.startsWith('http://') || saveForm.startsWith('https://'))
    ) {
      // 从 OSS 获取数据
      const response = await fetch(saveForm)
      if (!response.ok) {
        throw new Error(`请求失败: ${response.status}`)
      }
      const data = await response.json()
      saveForm = data
    }
  } catch (error) {
    console.error('获取历史设置数据失败:', error)
    message.error('获取历史设置数据失败')
  }
  saveRecordData(saveForm, store.state.preLayoutSetting.setting_value)
  const res = await savePrelayoutSetting({
    setting_value: saveForm,
    setting_id: settingId.value ? settingId.value : undefined,
  })
  if (res.status) {
    const newSetting = await getPrelayoutSetting()
    isLoadingSetting.value = false
    if (res.data) {
      settingId.value = res.data
    }
    if (saveForm.longPlankCuttingSetting.cutSingleDoor) {
      secondaryCuttingList.value.push('cutSingleDoor')
    }
    if (saveForm.longPlankCuttingSetting.cutGeneralPlank) {
      secondaryCuttingList.value.push('cutGeneralPlank')
    }
    store.commit('setPreLayoutSetting', newSetting.data)
    Object.assign(formData, saveForm)
    normalizeLongPlankCuttingSetting()
    // 特殊孔槽
    isShowCustSPHoleRule.value =
      formData.holeFaceSetting?.custom_special_hole_slot_side?.is_open ?? false
    Vue.prototype.$message({
      message: translateLang('preLayoutSetting.resetSuccess'),
      type: 'success',
    })
    isHistoryVisible.value = false
  }
  isLoadingSetting.value = false
}

const hanldeBackToHistoryList = () => {
  historyItem.value = null
}

const isEmptyKnife = computed(() => {
  if (store.state.userPermissions['allow_pre_layout_knife_diameter_0']) {
    return !formData.knife.diameter && formData.knife.diameter !== 0
  }
  return !formData.knife.diameter
})

const isHistoryDetail = computed(() => {
  return Boolean(historyItem.value)
})

const translateLang = (key: string) => {
  return translate(key) as string
}
const changeCheck = (e: any) => {
  isShowCustSPHoleRule.value = e.target.checked
  formData.holeFaceSetting.custom_special_hole_slot_side.is_open =
    e.target.checked
  specialHoleSlotRef?.value?.addStraightenerPX()
}
/**
 * @desc 改变特殊孔槽选项
 * @param data switch值
 */
/** 接口可能返回非常规类型，统一规范为组件所需类型 */
function normalizeLongPlankCuttingSetting() {
  const setting = formData.longPlankCuttingSetting
  if (!setting) return
  if (!Array.isArray(setting.desMaterialList)) {
    setting.desMaterialList =
      setting.desMaterialList && typeof setting.desMaterialList === 'object'
        ? Object.values(setting.desMaterialList)
        : []
  }
  if (typeof setting.desMaterialSwitch !== 'boolean') {
    setting.desMaterialSwitch = Boolean(setting.desMaterialSwitch)
  }
}

const changeSpSlotHole = (data: boolean) => {
  const target = formData.holeFaceSetting.custom_special_hole_slot_side
  if (!target) {
    formData.holeFaceSetting.custom_special_hole_slot_side = {
      is_open: data,
      special_hole_slot_side: [],
    }
    return
  }
  target.is_open = data
  if (data) return
  target.special_hole_slot_side =
    specialHoleSlotRef.value?.getAllRules().special_hole_slot_side ?? []
}
/**
 * 删除拉直器与....属性
 */
// const deleteStrHine = () => {
//   const tempVal = formData.holeFaceSetting.processChainAndHoleOnBigPlaneBack
//   delete formData.holeFaceSetting.processChainAndHoleOnBigPlaneBack
//   tempVal && handleSaveSetting()
// }
// 选择已封好边
const handleSelectEdge = (val: string) => {
  formData.sawSetting.edgeNoSawSide = val
}
/**
 * @desc 设置不生效翻面两次打穿孔
 * @param data switch值
 */
const handlePecialHoleAndSlotTableSwitch = (data: boolean) => {
  const target = formData.cuttingPunchingSetting.non_through_slot_two_side_cut
  if (!target) {
    formData.cuttingPunchingSetting.non_through_slot_two_side_cut = {
      is_open: data,
      special_hole_slot_side: [],
    }
    return
  }
  target.is_open = data
}

// 获取输入框显示的值
const getPlankNameValue = (index: number): string => {
  return (
    tempPlankNames[index]?.value ??
    formData.longPlankCuttingSetting.secondary_cutting_board_list[index] ??
    ''
  )
}

// 添加板件名
const handleAddPlankName = (): void => {
  const newIndex =
    formData.longPlankCuttingSetting.secondary_cutting_board_list.length
  formData.longPlankCuttingSetting.secondary_cutting_board_list.push('')
  // 初始化临时值
  tempPlankNames[newIndex] = {
    value: '',
    original: '',
  }
  buryPoint({
    function_module: 'preLayoutSetting',
    function_point: 'addPlankName',
  })
}

// 获得焦点时保存原始值
const handleFocusPlankName = (index: number): void => {
  const originalValue =
    formData.longPlankCuttingSetting.secondary_cutting_board_list[index] || ''
  // 如果还没有临时值，初始化它
  if (!tempPlankNames[index]) {
    tempPlankNames[index] = {
      value: originalValue,
      original: originalValue,
    }
  } else {
    // 如果已有临时值，更新原始值（防止多次获得焦点）
    tempPlankNames[index].original = originalValue
  }
  currentInputIndex.value = index
}

// 输入时更新临时值
const handleInputPlankName = (e: any, index: number): void => {
  const value = e?.target.value
  if (!tempPlankNames[index]) {
    tempPlankNames[index] = {
      value: value,
      original:
        formData.longPlankCuttingSetting.secondary_cutting_board_list[index] ||
        '',
    }
  } else {
    tempPlankNames[index].value = value
  }
  currentInputPlankName.value = value
  currentInputIndex.value = index
}

// 失焦时如果没有保存，恢复原值
const handleBlurPlankName = (index: number): void => {
  // 延迟执行，确保点击保存按钮时不会触发
  setTimeout(() => {
    // 如果当前索引不是这个输入框，说明可能点击了保存或其他操作，不恢复
    if (currentInputIndex.value !== index) {
      return
    }
    // 如果没有保存，恢复原值
    if (tempPlankNames[index]) {
      tempPlankNames[index].value = tempPlankNames[index].original
      currentInputIndex.value = null
    }
  }, 200)
}

// 删除板件名
const handleDelPlank = (index: number): void => {
  if (
    formData.longPlankCuttingSetting.longPlankCuttingEnable &&
    formData.longPlankCuttingSetting.specified_board_secondary_cutting
  ) {
    formData.longPlankCuttingSetting.secondary_cutting_board_list.splice(
      index,
      1
    )
    // 清理临时值
    delete tempPlankNames[index]
    // 重新整理索引
    const newTempPlankNames: Record<
      number,
      { value: string; original: string }
    > = {}
    Object.keys(tempPlankNames).forEach((key) => {
      const numKey = Number(key)
      if (numKey < index) {
        newTempPlankNames[numKey] = tempPlankNames[numKey]
      } else if (numKey > index) {
        newTempPlankNames[numKey - 1] = tempPlankNames[numKey]
      }
    })
    Object.keys(newTempPlankNames).forEach((key) => {
      tempPlankNames[Number(key)] = newTempPlankNames[Number(key)]
    })
    Object.keys(tempPlankNames).forEach((key) => {
      if (!newTempPlankNames[Number(key)]) {
        delete tempPlankNames[Number(key)]
      }
    })
  }
}

// 保存板件名
const handleSavePlankName = (name: string, index: number): void => {
  if (formData.longPlankCuttingSetting.specified_board_secondary_cutting) {
    // 立即清除索引，防止失焦事件恢复值
    currentInputIndex.value = null
    const valueToSave =
      tempPlankNames[index]?.value ?? currentInputPlankName.value

    // 如果输入值不为空，检查是否有重复
    if (valueToSave && valueToSave.trim()) {
      const boardList =
        formData.longPlankCuttingSetting.secondary_cutting_board_list
      const trimmedValue = valueToSave.trim()

      // 检查是否有重复（排除当前索引）
      const duplicateIndex = boardList.findIndex(
        (item: string, idx: number) =>
          idx !== index && item && item.trim() === trimmedValue
      )

      if (duplicateIndex !== -1) {
        // 有重复，显示错误提示并恢复原始值
        Vue.prototype.$message.error('板件名不能重复')
        // 恢复原始值
        const originalValue =
          tempPlankNames[index]?.original ??
          formData.longPlankCuttingSetting.secondary_cutting_board_list[
            index
          ] ??
          ''
        if (tempPlankNames[index]) {
          tempPlankNames[index].value = originalValue
        }
        // 恢复表单中的值
        Vue.prototype.$set(
          formData.longPlankCuttingSetting.secondary_cutting_board_list,
          index,
          originalValue
        )
        return
      }
    }

    // 没有重复，正常保存
    Vue.prototype.$set(
      formData.longPlankCuttingSetting.secondary_cutting_board_list,
      index,
      valueToSave
    )
    // 更新临时值的原始值，以便下次编辑时使用
    if (tempPlankNames[index]) {
      tempPlankNames[index].original = valueToSave
    }
  }
}

onMounted(async () => {
  const res = await getPrelayoutSetting()
  if (res.status) {
    isLoadingSetting.value = false
    Object.assign(formData, res.data.setting_value)
    normalizeLongPlankCuttingSetting()
    if (res.data.id) {
      settingId.value = res.data.id
    }
    if (formData.longPlankCuttingSetting.cutSingleDoor) {
      secondaryCuttingList.value.push('cutSingleDoor')
    }
    if (formData.longPlankCuttingSetting.cutGeneralPlank) {
      secondaryCuttingList.value.push('cutGeneralPlank')
    }
    store.commit('setPreLayoutSetting', JSON.parse(JSON.stringify(res.data)))
  } else {
    Vue.prototype.$message({
      message: translate('preLayoutSetting.fetchErr'),
      type: 'error',
    })
  }
  // 获取偏好设置
  // todo delete
  // await store.dispatch('preferencesSetting/getSetting')
  // 特殊孔槽规则开关赋值
  isShowCustSPHoleRule.value =
    formData.holeFaceSetting.custom_special_hole_slot_side.is_open
  // isHistoryListLoading.value = true
  // setTimeout(() => {
  //   isHistoryListLoading.value = false
  //   historyList.value = [{ createTime: '120020', setting: {} }]
  // }, 1000)
  Navigate.getInstance().registerEvent('/preLayoutSetting', {
    waitLoadDone: () => (isLoadingSetting.value ? 0 : 1),
  })
})

onUnmounted(() => {
  Navigate.getInstance().unregisterEvent('/preLayoutSetting')
})

return { __sfc: true,info, engravSwitchCloseAlwaysShow, paringPointList, paringImg, anchorNavRef, positionDisList, lavePointList, clampHandDirectionMap, clampHandPositioin, container, navs, positionDisValue, plateGighGlossOptions, secondaryCuttingList, secondaryCuttingOptions, isLoadingSetting, settingId, hasChangeSetting, isHistoryVisible, historyList, isHistoryListLoading, historyItem, currentItemIndex, isShowCustSPHoleRule, specialHoleSlotRef, specialHoleSlotRef2, formData, accordTextureCut, edgeDirArr, currentInputPlankName, currentInputIndex, tempPlankNames, handleChosePoint, handleParDir, laveImg, lavePoint, isLongPlankCuttingDisabled, handleChoselavePoint, handleSelectCutting, handlerChangeAccordMSw, handleFlattenObject, handleBury, handleSaveSetting, saveRecordData, dealDataType, inputLimit, onInputBlur, handleCheckHistory, handeeChangeClamlHandPosition, handleCheckDetail, handleReset, resetFunc, hanldeBackToHistoryList, isEmptyKnife, isHistoryDetail, translateLang, changeCheck, normalizeLongPlankCuttingSetting, changeSpSlotHole, handleSelectEdge, handlePecialHoleAndSlotTableSwitch, getPlankNameValue, handleAddPlankName, handleFocusPlankName, handleInputPlankName, handleBlurPlankName, handleDelPlank, handleSavePlankName, AnchorNav, MAccordTextureCut, mSpecialHoleAndSlotTable, mHistoryList, mMachinePos, mSettingContent }
}

})